import { xoxoApi, kioskApi } from '../axios.js';
// Local shop API that calls our backend (kioskApi)
export const shopApi = {
    // Get all shops through our backend
    getAllShops() {
        return kioskApi.get('/admin/shops');
    },
    // Get shop by ID through our backend
    getShopById(shopId) {
        return kioskApi.get(`/admin/shops/${shopId}`);
    },
    // Admin functions that use our backend
    // Upsert shops: fetches all shops from XOXO API and creates/updates them in local DB
    upsertShops() {
        return kioskApi.post('/admin/shops/seed');
    },
    // Legacy alias for backward compatibility
    seedShops() {
        return this.upsertShops();
    },
    nukeAllShops() {
        return kioskApi.delete('/admin/shops/nuke');
    },
    updateOrderDefaults(shopId, defaults) {
        return kioskApi.patch(`/admin/shops/${shopId}/order-defaults`, defaults);
    },
    // Update shop recipes
    updateShopRecipes(shopId, recipes) {
        return kioskApi.patch(`/admin/shops/${shopId}/recipes`, { recipes });
    },
    // Fetch and update shop recipes from XOXO API through our backend
    fetchAndUpdateShopRecipes(shopId) {
        return kioskApi.post(`/admin/shops/${shopId}/fetch-and-update-recipes`);
    },
    // Get all orders for a shop (optionally filter by kiosk instance)
    getOrdersForShop(shopId, opts) {
        const params = {};
        if (opts?.kioskInstanceCode)
            params.kioskInstanceCode = opts.kioskInstanceCode;
        return kioskApi.get(`/admin/shops/${shopId}/orders`, { params });
    }
};
// XOXO API client for direct XOXO API access (used by backend)
export const xoxoShopApi = {
    // Get all shops directly from XOXO API
    getAllShops() {
        return xoxoApi.get('/admin/shops');
    },
    // Get shop by ID directly from XOXO API
    getShopById(shopId) {
        return xoxoApi.get(`/admin/shops/${shopId}`);
    }
};
